import { render } from "./About.vue?vue&type=template&id=a38cb084"
const script = {}
script.render = render

export default script